"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var lodash_1 = __importDefault(require("lodash"));
var constants_1 = require("../../../constants");
var locale_currency_pipe_1 = require("../../../filters/locale-currency.pipe");
var locale_date_time_pipe_1 = require("../../../filters/locale-date-time.pipe");
var locale_date_pipe_1 = require("../../../filters/locale-date.pipe");
var locale_number_pipe_1 = require("../../../filters/locale-number.pipe");
var core_2 = require("@ngx-translate/core");
var AlertsComponent = /** @class */ (function () {
    function AlertsComponent(localeDateTime, localeDate, localeCurrency, localeNumber, translateService) {
        this.localeDateTime = localeDateTime;
        this.localeDate = localeDate;
        this.localeCurrency = localeCurrency;
        this.localeNumber = localeNumber;
        this.translateService = translateService;
        this.alertNames = lodash_1.default.invert(constants_1.AlertTypes);
        this.alertTypeDescriptors = constants_1.AlertTypeDescriptors;
        this.alertTypes = constants_1.AlertTypes;
    }
    AlertsComponent.prototype.ngOnInit = function () {
    };
    AlertsComponent.prototype.ngOnChanges = function (changes) {
        if (changes.showRelavantInfo && changes.showRelavantInfo.currentValue !== null) {
            // Sometimes the showRelevantInfo input comes over as a string
            if (typeof changes.showRelavantInfo.currentValue === 'string') {
                // tslint:disable-next-line:triple-equals
                this.showRelavantInfo = (changes.showRelavantInfo.currentValue.toLowerCase() == 'true');
            }
        }
        if (changes.values && changes.values.currentValue) {
            if (this.showRelavantInfo) {
                this.updateAlerts();
            }
        }
    };
    AlertsComponent.prototype.alertStyle = function (alertValue) {
        if (alertValue && alertValue.details && alertValue.type) {
            return 'fa fa' + this.alertNames[alertValue.type].toLowerCase();
        }
        else {
            return 'fa fa' + this.alertNames[alertValue].toLowerCase();
        }
    };
    AlertsComponent.prototype.getAlertLetterKey = function (alertValue) {
        var key = lodash_1.default.find(this.alertTypeDescriptors, function (item) {
            if (item === alertValue) {
                return true;
            }
            if (alertValue && item.id === alertValue.toString()) {
                return true;
            }
            if (alertValue && alertValue.type && item.id === alertValue.type.toString()) {
                return true;
            }
        });
        if (key == null || key.translateKey == null) {
            return null;
        }
        return key.translateKey;
    };
    AlertsComponent.prototype.updateAlerts = function () {
        for (var i = 0; i < this.values.length; i++) {
            var alert_1 = this.values[i];
            switch (alert_1.type) {
                case this.alertTypes.alert:
                case this.alertTypes.flexAlert:
                    this.setAlertLocaleData(alert_1);
                    break;
                case this.alertTypes.service:
                    this.setServiceAlertLocaleData(alert_1);
                    break;
                case this.alertTypes.appointment:
                    this.setAppointmentAlertLocaleData(alert_1);
                    break;
                case this.alertTypes.contractEnd:
                    this.setContractEndAlertLocaleData(alert_1);
                    break;
                case this.alertTypes.mileage:
                    this.setMileageAlertLocaleData(alert_1);
                    break;
                case this.alertTypes.warranty:
                    this.setWarrantyAlertLocaleData(alert_1);
                    break;
                default:
                    break;
            }
            this.setAlertMessage(alert_1);
        }
    };
    AlertsComponent.prototype.setAlertLocaleData = function (alert) {
        alert.localeData = {
            year: alert.details.yearID,
            make: alert.details.makeName,
            model: alert.details.modelName,
            trim: alert.details.trimName,
            term: alert.details.contractTerm,
            amount: this.localeCurrency.transform(alert.details.payment),
            difference: this.localeCurrency.transform(Math.abs(alert.details.paymentDifferenceAmount)),
            differenceLabel: alert.details.paymentDifferenceAmount > 0 ? 'more' : 'less'
        };
    };
    AlertsComponent.prototype.setServiceAlertLocaleData = function (alert) {
        alert.localeData = {
            repairOrderDate: alert.details.openDate != null ? this.localeDate.transform(alert.details.openDate) : "",
            total: alert.details.eighteenMonthServiceCount
        };
    };
    AlertsComponent.prototype.setAppointmentAlertLocaleData = function (alert) {
        alert.localeData = {
            appointmentDate: alert.details.appointmentDate != null ? this.localeDateTime.transform(alert.details.appointmentDate) : ""
        };
    };
    AlertsComponent.prototype.setContractEndAlertLocaleData = function (alert) {
        alert.localeData = {
            made: alert.details.paymentsMade,
            remaining: alert.details.paymentsRemaining
        };
    };
    AlertsComponent.prototype.setMileageAlertLocaleData = function (alert) {
        alert.localeData = {
            projectedMileage: this.localeNumber.transform(alert.details.estimatedMaturityMileage),
            currentPenalty: this.localeCurrency.transform(alert.details.currentMileagePenalty),
            projectedPenalty: this.localeCurrency.transform(alert.details.estimatedMileagePenalty)
        };
    };
    AlertsComponent.prototype.setWarrantyAlertLocaleData = function (alert) {
        alert.localeData = {
            months: alert.details.warrantyMonthsRemaining,
            miles: this.localeNumber.transform(alert.details.warrantyMilesRemaining)
        };
    };
    // We're performing the translation here instead of in the template because Angular's {{...}} is encoding
    // &nbsp; to &#160, which is the numeric representation of a non-blank space.  This was causing &#160
    // to be displayed literally on the page instead of a non-blank space.  We're using the ng-bind-html to inject
    // alert.message into the template so the double-encoding doesn't occur.
    // Example: <span ... ng-bind-html="alert.message"></span>
    AlertsComponent.prototype.setAlertMessage = function (alert) {
        var _this = this;
        var alertLetterKey = this.getAlertLetterKey(alert);
        var translateKey = '';
        if (alert && alert.translateKey) {
            translateKey = alert.translateKey;
        }
        this.translateService.get([translateKey, alertLetterKey], alert.localeData)
            .subscribe(function (translationSet) {
            alert.message =
                '<span class="alerts-letterblock ' + _this.alertStyle(alert.type) +
                    '" title="' + translationSet[alert.translateKey] + '">' + translationSet[alertLetterKey] + '</span>';
        }, function (translationId) {
            alert.message = '<span class="alerts-letterblock ' + _this.alertStyle(alert.type) + '" title="' + translationId + '"></span>';
        });
    };
    return AlertsComponent;
}());
exports.AlertsComponent = AlertsComponent;
